import { z } from "zod";

import {
  HistoryActionList,
  HistoryDtoSchema,
  ResourceIdKeyList,
} from "../../../dtos/history";

export const PostHistoryRequestBodySchema = z.object({
  experienceId: z.string().uuid(),
  action: z.enum(HistoryActionList),
});
export type PostHistoryRequestBodyType = z.infer<
  typeof PostHistoryRequestBodySchema
>;

export const PostHistoryResponseBodySchema = z.object({
  history: HistoryDtoSchema.array(),
});
export type PostHistoryResponseBodyType = z.infer<
  typeof PostHistoryResponseBodySchema
>;
